
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"6","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.328 12.48c-.459 0-.79-.16-.992-.48-.192-.31-.288-.699-.288-1.168 0-.512.096-1.12.288-1.824.192-.704.443-1.445.752-2.224.32-.779.667-1.536 1.04-2.272a26.78 26.78 0 011.12-2.032c.373-.608.715-1.093 1.024-1.456.32-.363.57-.544.752-.544.117 0 .213.07.288.208.075.128.133.288.176.48.043.181.064.347.064.496 0 .288-.075.667-.224 1.136a12.08 12.08 0 01-.608 1.552 15.294 15.294 0 01-.928 1.728c-.352.576-.741 1.13-1.168 1.664A8.6 8.6 0 011.296 9.12c-.064.288-.117.57-.16.848a6.452 6.452 0 00-.048.768c0 .416.059.725.176.928a.572.572 0 00.528.304c.288 0 .57-.128.848-.384a4.55 4.55 0 00.8-.96c.256-.395.475-.8.656-1.216l.24.128c-.427.907-.89 1.627-1.392 2.16-.501.523-1.04.784-1.616.784zm.112-3.904c.373-.373.736-.8 1.088-1.28.352-.49.677-.997.976-1.52.31-.523.581-1.03.816-1.52s.416-.928.544-1.312c.128-.395.192-.699.192-.912 0-.107-.016-.176-.048-.208-.021-.032-.043-.048-.064-.048-.085 0-.235.139-.448.416-.203.267-.443.63-.72 1.088-.277.459-.56.981-.848 1.568-.288.587-.565 1.2-.832 1.84-.256.64-.475 1.27-.656 1.888z","fill":"currentColor"}})])
          )
        }
      }
    